/**
 * Collection BandWare drawer — Apple Watch + Royal Pop.
 * Reuses B1PreviewKit from studio-preview-kit.js (same logic as B¹ Studio).
 */
(function () {
  'use strict';

  function getKit() {
    return window.B1PreviewKit;
  }

  function buildConfigUrl(pathname, config, preserveSearch) {
    var kit = getKit();
    if (kit && kit.buildConfigUrl) return kit.buildConfigUrl(pathname, config, preserveSearch);
    return pathname;
  }

  function setSharedHeaderCloseState(active) {
    var hamburger = document.querySelector('#hamburger-button, header-drawer .hamburger');
    if (hamburger && hamburger.classList) hamburger.classList.toggle('active', !!active);
    document.body.classList.toggle('studio-collection-header-close-active', !!active);
  }

  function finishSlugForLayers(finish) {
    if (!finish) return '';
    return String(finish)
      .toLowerCase()
      .replace(/\u2019/g, "'")
      .replace(/[\s_]+/g, '')
      .trim();
  }

  function normLocal(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[™®©]/g, '')
      .replace(/[¹]/g, '1')
      .replace(/[^a-z0-9]+/g, '')
      .trim();
  }


  function inferWatchWareHost(entry) {
    var raw = [
      entry && entry.hostKind,
      entry && entry.host_kind,
      entry && entry.hostDevice,
      entry && entry.host_device,
      entry && entry.lineHostDevice,
      entry && entry.profileName,
      entry && entry.line,
      entry && entry.productTitle,
      entry && entry.productHandle,
      entry && entry.title,
    ].filter(Boolean).join(' ');
    var n = normLocal(raw);
    if (n === 'royal' || n.indexOf('royalpop') >= 0 || n.indexOf('b1head') >= 0 || n.indexOf('bhead') >= 0) return 'royal';
    if (n === 'apple' || n.indexOf('applewatch') >= 0) return 'apple';
    return '';
  }

  function isB1WatchWareEntry(entry) {
    var lineNorm = normLocal(entry && (entry.line || entry.lineName || entry.line_label || entry.lineLabel));
    var hay = [entry && entry.line, entry && entry.profileName, entry && entry.productTitle, entry && entry.productHandle, entry && entry.title].filter(Boolean).join(' ');
    var n = normLocal(hay);
    if (!n) return true;

    // v76d: Collection Studio must use the same B¹-eligible WatchWare family as B¹ Studio.
    // Legacy/archive families should not be offered as B¹ WatchWare choices. Keep this as
    // a conservative guard until the backend exposes a dedicated b1_compatible flag.
    if (n.indexOf('active') >= 0 || n.indexOf('core') >= 0 || n.indexOf('titan') >= 0) return false;
    if (n.indexOf('essential') >= 0) return false;
    if (lineNorm === 'steel') return false;
    return true;
  }

  function filterWatchWareEntries(entries, isRoyal) {
    return (entries || []).filter(function (entry) {
      if (!isB1WatchWareEntry(entry)) return false;
      var host = inferWatchWareHost(entry);
      if (isRoyal) return host !== 'apple'; // dedicated Royal list may omit or mislabel host metadata
      return host === 'apple' || host === '';
    });
  }

  function optByIndexLocal(variant, idx) {
    var n = Number(idx || 0) + 1;
    return variant ? variant['option' + n] : null;
  }

  function collectionEntryFinish(entry) {
    if (!entry) return '';
    return entry.color || entry.finish || entry.bandFinish || entry.displayTitle || '';
  }

  function deriveLinkFinishForEntry(bandModule, entry) {
    var desired = collectionEntryFinish(entry);
    var finishes = bandModule && bandModule.getAvailableFinishes ? bandModule.getAvailableFinishes() : [];
    if (desired && finishes && finishes.length) {
      for (var i = 0; i < finishes.length; i++) {
        if (normLocal(finishes[i]) === normLocal(desired)) return finishes[i];
      }
    }
    return (bandModule && bandModule.state && bandModule.state.linkFinish) || (finishes && finishes[0]) || desired || null;
  }

  function entryRequiresInterfaceLink(entry) {
    // Collection Direct mode is a visual configuration surface. If a B¹ Link finish is selected,
    // the card preview and product links should carry that finish for every BandWare card.
    return !!entry;
  }

  function stripEmptyConfigValues(config) {
    var out = Object.assign({}, config || {});
    Object.keys(out).forEach(function (key) {
      if (out[key] == null || out[key] === '') delete out[key];
    });
    return out;
  }

  function connectorImageForFinish(bandModule, finish) {
    if (!bandModule || !finish || !bandModule.bLink) return null;
    var kit = getKit();
    if (!kit || !kit.resolveB1LinkStudioImage) return null;
    var linkSize = bandModule.getLinkSizeLabel && bandModule.getLinkSizeLabel();
    return kit.resolveB1LinkStudioImage(bandModule.bLink, finish, linkSize);
  }

  /**
   * Apple collection Direct — device + band + B¹ lug overlay (not studio strap-attach math).
   */
  function buildAppleCollectionDirectLayers(bandModule, entry) {
    var derivedFinish = bandModule && bandModule.state && bandModule.state.linkFinish
      ? bandModule.state.linkFinish
      : (entryRequiresInterfaceLink(entry) ? deriveLinkFinishForEntry(bandModule, entry) : null);
    var frameSrc = derivedFinish ? connectorImageForFinish(bandModule, derivedFinish) : null;
    var b1Key = frameSrc
      ? finishSlugForLayers(derivedFinish || bandModule.state.linkFinish) + '|' + frameSrc
      : '';
    var appleGeometry = bandModule.getAppleGeometry ? bandModule.getAppleGeometry() : null;
    var appleOffsetXPct = appleGeometry && appleGeometry.interfaceOffsetXPct != null ? appleGeometry.interfaceOffsetXPct : 0;
    return {
      base: bandModule.getDeviceImage(),
      band: entry && entry.topBand ? entry.topBand : null,
      connector: entry && entry.bottomBand ? entry.bottomBand : null,
      showConnector: !!(entry && entry.bottomBand),
      b1Connector: frameSrc,
      b1ConnectorKey: b1Key,
      showB1Connectors: !!frameSrc,
      collectionB1Overlay: !!frameSrc,
      normalizeBase: false,
      royalDirectComposition: false,
      strapHeightRatio: null,
      crownPosition: null,
      appleDeviceOffsetXPct: appleOffsetXPct,
    };
  }

  function previewStackInnerHtml() {
    return (
      '<div class="studio-preview__stack studio-collection-card-preview__stack" data-studio-preview="active">' +
      '<div class="studio-preview__layer-wrap studio-preview__layer-wrap--b1-bottom">' +
      '<img class="studio-preview__layer studio-preview__layer--b1-bottom" data-layer="b1-bottom" alt="" loading="lazy" decoding="async" />' +
      '</div>' +
      '<div class="studio-preview__layer-wrap studio-preview__layer-wrap--connector">' +
      '<img class="studio-preview__layer studio-preview__layer--connector" data-layer="connector" alt="" loading="lazy" decoding="async" />' +
      '</div>' +
      '<div class="studio-preview__layer-wrap studio-preview__layer-wrap--b1-top">' +
      '<img class="studio-preview__layer studio-preview__layer--b1-top" data-layer="b1-top" alt="" loading="lazy" decoding="async" />' +
      '</div>' +
      '<div class="studio-preview__layer-wrap studio-preview__layer-wrap--base">' +
      '<img class="studio-preview__layer studio-preview__layer--base" data-layer="base" alt="" loading="lazy" decoding="async" />' +
      '</div>' +
      '<div class="studio-preview__layer-wrap studio-preview__layer-wrap--band">' +
      '<img class="studio-preview__layer studio-preview__layer--band" data-layer="band" alt="" loading="lazy" decoding="async" />' +
      '</div>' +
      '</div>'
    );
  }

  function CollectionBandConfigurator(sectionRoot, data) {
    this.root = sectionRoot;
    if (this.root) this.root.__b1CollectionBandInstance = this;
    this.data = data;
    this.kit = getKit();
    if (!this.kit) {
      console.error('B1PreviewKit missing — load studio-preview-kit.js first');
      return;
    }

    this.urlP = this.kit.B1_CONFIG_URL;
    this.platform = data.platform || sectionRoot.getAttribute('data-b1-coll-platform') || 'apple';
    this.isRoyal = this.platform === 'royal';
    this.norm = this.kit.norm;
    this.watchWareEntries = filterWatchWareEntries(
      this.isRoyal ? (data.royalPopWatchWareEntries || []) : (data.appleWatchWareEntries || []),
      this.isRoyal
    );
    // V5: the drawer should be driven by the emitted normalized WatchWare entries.
    // Some live section settings can still point to the legacy metaobject handle,
    // so do not let a stale hasWatchWare flag block the WatchWare tab.
    this.hasWatchWare = !!(this.watchWareEntries && this.watchWareEntries.length);
    this.mode = 'direct';

    this.bandModule = new this.kit.BandWareModule(data, null, [], {
      directKey: this.isRoyal ? 'royal_pop' : 'apple_watch',
      collectionPreview: true,
    });
    this.bandModule.entries = data.collectionBandWareEntries || [];
    this.bandModule.state.adapterEnabled = true;

    if (this.isRoyal && data.appleReferenceDeviceImage && this.kit.initCollAppleReferenceProbe) {
      this.kit.initCollAppleReferenceProbe(data.appleReferenceDeviceImage);
      var self = this;
      window.addEventListener(
        'b1-coll-apple-ref-ready',
        function () {
          self._updateAllCardPreviews(true);
        },
        { once: true }
      );
    }

    if (this.hasWatchWare) {
      this.watchWareModule = new this.kit.AppleWatchWareMetaModule(this.watchWareEntries);
    }

    this.entriesByProductId = Object.create(null);
    (this.bandModule.entries || []).forEach(
      function (entry) {
        if (entry && entry.productId) this.entriesByProductId[String(entry.productId)] = entry;
      }.bind(this)
    );

    this.drawer = sectionRoot.querySelector('[data-b1-coll-drawer]');
    this.panelDirect = sectionRoot.querySelector('[data-b1-coll-panel-direct]');
    this.panelWatchware = sectionRoot.querySelector('[data-b1-coll-panel-watchware]');
    document.body.classList.add('studio-collection-apple-active');
    this.isConfigured = false;
    this._cardEngines = [];
    this._onPopState = this._handlePopState.bind(this);
    if (this.isRoyal) {
      if (this.data.royalModels && this.data.royalModels.length) {
        this.bandModule.selectRoyalModel(0);
      }
    }
    this._ensureModeTabs();
    this._bindContextBarTrigger();
    this._mountFloatingTrigger();
    this._bindUi();
    this._ensureRefineCloseButton();
    this._bindCollectionAccordions();
    this._enhanceProductCards();
    this._observeGrid();
    if (this.isRoyal) this._renderRoyalModelButtons();
    if (this.isRoyal) this._renderFrameTypeButtons();
    this._renderFinishButtons();
    if (this.hasWatchWare) this._renderWatchWareControls();
    this._applyModeUi();
    this._applyFromUrl(true);
    window.addEventListener('popstate', this._onPopState);
    this._updateBottomSummary();
    if (!this.isRoyal && this.kit.initCollAppleMaxDeviceProbe) {
      this.kit.initCollAppleMaxDeviceProbe(this.data.appleSizes || []);
      var self = this;
      window.addEventListener(
        'b1-coll-apple-max-device-ready',
        function () {
          if (self.isConfigured) self._updateAllCardPreviews(true);
        },
        { once: false }
      );
    }
  }

  CollectionBandConfigurator.prototype.destroy = function () {
    window.removeEventListener('popstate', this._onPopState);
    if (this._contextBarOpenHandler) document.removeEventListener('brilinton:collection-studio-open', this._contextBarOpenHandler);
    if (this._gridObs) this._gridObs.disconnect();
    if (this.floatingTrigger && this.floatingTrigger.isConnected) this.floatingTrigger.remove();
    this.floatingTrigger = null;
    document.documentElement.classList.remove('studio-collection--configured');
    document.documentElement.classList.remove('b1-coll-band--watchware');
    document.body.classList.remove('studio-collection-refine-open');
  };

  CollectionBandConfigurator.prototype._ensureModeTabs = function () {
    if (!this.drawer) return;

    var existingTabs = this.drawer.querySelector('[data-b1-coll-mode-tabs]');
    if (existingTabs) {
      var directButton = existingTabs.querySelector('[data-b1-coll-mode="direct"]');
      var watchwareButton = existingTabs.querySelector('[data-b1-coll-mode="watchware"]');

      // Liquid can render before its availability probe resolves the line metaobject.
      // Reconcile the row from the normalized entries that actually reached the browser.
      if (this.hasWatchWare && !watchwareButton) {
        watchwareButton = document.createElement('button');
        watchwareButton.type = 'button';
        watchwareButton.className = 'studio__option';
        watchwareButton.setAttribute('data-b1-coll-mode', 'watchware');
        watchwareButton.setAttribute('data-studio-option', 'mode');
        watchwareButton.setAttribute('data-option-value', 'watchware');
        watchwareButton.setAttribute('aria-selected', 'false');
        watchwareButton.textContent = 'WatchWare';
        existingTabs.insertBefore(watchwareButton, directButton || existingTabs.firstChild);
      } else if (!this.hasWatchWare && watchwareButton) {
        watchwareButton.remove();
      }
      return;
    }

    // Legacy fallback for older section markup without the Pairing option row.
    var head = this.drawer.querySelector('.studio__header');
    var body = this.drawer.querySelector('.studio__body');
    if (!head || !body) return;

    var nav = document.createElement('nav');
    nav.className = 'studio__pairing-options';
    nav.setAttribute('data-b1-coll-mode-tabs', '');
    nav.setAttribute('aria-label', 'Configuration mode');
    nav.innerHTML =
      '<div class="studio__button-grid" role="tablist">' +
      (this.hasWatchWare ? '<button type="button" class="studio__collection-drawer__mode-tab" data-b1-coll-mode="watchware" role="tab" aria-selected="false">WatchWare</button>' : '') +
      '<button type="button" class="studio__collection-drawer__mode-tab is-active is-selected" data-b1-coll-mode="direct" role="tab" aria-selected="true">' +
      (this.isRoyal ? 'Direct to Royal Pop' : 'Direct') +
      '</button></div>';

    head.insertAdjacentElement('afterend', nav);

    var wwPanel = body.querySelector('[data-b1-coll-panel-watchware]');
    var directPanel = body.querySelector('[data-b1-coll-panel-direct]');
    if (this.hasWatchWare && !wwPanel) {
      var ww = document.createElement('div');
      ww.className = 'studio__branch studio__branch--watchware is-hidden';
      ww.setAttribute('data-b1-coll-panel-watchware', '');
      ww.innerHTML =
        '<section class="studio__group" data-studio-group data-studio-group-id="watchware">' +
        '<p class="studio__field-label">WatchWare:</p>' +
        '<p class="studio__field-label">Line:</p>' +
        '<div class="studio__option-row studio__option-row--sub" data-b1-coll-ww-lines role="group"></div>' +
        '<p class="studio__field-label">Finish:</p>' +
        '<div class="studio-rail studio-rail__track" data-studio-collection-ww-colors role="group"></div>' +
        '</section>';
      if (directPanel) body.insertBefore(ww, directPanel);
      else body.appendChild(ww);
      this.panelWatchware = ww;
    }
    if (!directPanel) this.panelDirect = body;
  };


  CollectionBandConfigurator.prototype._floatingTriggerLabel = function () {
    return 'Open Studio';
  };

  CollectionBandConfigurator.prototype._bindContextBarTrigger = function () {
    if (this._contextBarOpenHandler) return;
    var self = this;
    this._contextBarOpenHandler = function (event) {
      var requested = event && event.detail ? event.detail.platform : '';
      var ownPlatform = self.isRoyal ? 'royal' : 'apple';
      if (requested && requested !== ownPlatform) return;
      self._openDrawer();
    };
    document.addEventListener('brilinton:collection-studio-open', this._contextBarOpenHandler);
  };

  CollectionBandConfigurator.prototype._mountFloatingTrigger = function () {
    if (!this.root) return;
    var existingFloating = this.root.querySelector('[data-studio-collection-floating-trigger]');
    var showFloatingTrigger = this.root.getAttribute('data-studio-floating-trigger') === 'true';

    if (!showFloatingTrigger) {
      if (existingFloating) existingFloating.remove();
      this.floatingTrigger = null;
      return;
    }

    if (this.floatingTrigger && this.floatingTrigger.isConnected) return;
    if (existingFloating) {
      this.floatingTrigger = existingFloating;
      return;
    }
    var platform = this.root.getAttribute('data-b1-coll-platform') || (this.isRoyal ? 'royal' : 'apple');
    var label = this._floatingTriggerLabel();

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'collection-studio-trigger collection-studio-trigger--' + platform;
    trigger.setAttribute('data-b1-coll-open', '');
    trigger.setAttribute('data-studio-collection-floating-trigger', '');
    trigger.setAttribute('aria-label', label);
    trigger.setAttribute('aria-expanded', 'false');

    var text = document.createElement('span');
    text.className = 'collection-studio-trigger__label';
    text.textContent = label;

    var arrow = document.createElement('span');
    arrow.className = 'collection-studio-trigger__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.innerHTML = '<svg class="icon icon-caret" viewBox="0 0 10 6" focusable="false" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>';

    trigger.appendChild(text);
    trigger.appendChild(arrow);
    this.root.appendChild(trigger);
    this.floatingTrigger = trigger;

    // The floating Studio trigger does not own or intercept the site menu.

  };

  CollectionBandConfigurator.prototype._bindToolbarControlListeners = function () {
    var self = this;
    if (this.toolbarTrigger && !this.toolbarTrigger.dataset.b1CollToolbarBound) {
      this.toolbarTrigger.dataset.b1CollToolbarBound = '1';
      this.toolbarTrigger.addEventListener('click', function () {
        if (self.drawer && self.drawer.classList.contains('is-open')) self._closeDrawer();
        else self._openDrawer();
      });
    }
    if (this.refineTrigger && !this.refineTrigger.dataset.b1CollToolbarBound) {
      this.refineTrigger.dataset.b1CollToolbarBound = '1';
      this.refineTrigger.addEventListener('click', function () {
        self._openRefineDrawer();
      });
    }
  };

  /** Mobile: hide B¹ / Filter toolbar while a collection drawer is open (sticky bar overlaps drawer). */
  CollectionBandConfigurator.prototype._syncMobileToolbarVisibility = function () {
    if (!document.body.classList.contains('studio-collection-apple-active')) return;

    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var previewOpen =
      document.body.classList.contains('studio-collection-preview-open') ||
      document.body.classList.contains('studio-collection-open');
    var refineOpen = document.body.classList.contains('studio-collection-refine-open');
    var drawerOpen = previewOpen || refineOpen;
    var bar = document.querySelector('[data-studio-collection-controlbar]');
    var facetsWrap =
      document.querySelector('aside#main-collection-filters .facets-wrapper') ||
      document.querySelector('.facets-wrapper');

    document.body.classList.toggle('studio-collection-mobile-drawer-open', mobile && drawerOpen);

    if (!mobile) {
      if (bar) {
        bar.classList.remove('studio-collection__controlbar--suppressed');
        bar.style.removeProperty('display');
        bar.style.removeProperty('visibility');
        bar.style.removeProperty('opacity');
        bar.style.removeProperty('pointer-events');
        bar.style.display = 'flex';
      }
      if (facetsWrap) {
        facetsWrap.classList.remove('facets-wrapper--drawer-suppressed');
        facetsWrap.style.removeProperty('display');
        facetsWrap.style.removeProperty('visibility');
        facetsWrap.style.removeProperty('opacity');
        facetsWrap.style.removeProperty('pointer-events');
      }
      return;
    }

    if (bar) {
      if (drawerOpen) {
        bar.classList.add('studio-collection__controlbar--suppressed');
        bar.style.setProperty('display', 'none', 'important');
        bar.style.setProperty('visibility', 'hidden', 'important');
        bar.style.setProperty('opacity', '0', 'important');
        bar.style.setProperty('pointer-events', 'none', 'important');
      } else {
        bar.classList.remove('studio-collection__controlbar--suppressed');
        bar.style.removeProperty('display');
        bar.style.removeProperty('visibility');
        bar.style.removeProperty('opacity');
        bar.style.removeProperty('pointer-events');
        bar.style.display = 'grid';
      }
    }

    if (facetsWrap) {
      if (previewOpen && !refineOpen) {
        facetsWrap.classList.add('facets-wrapper--drawer-suppressed');
        facetsWrap.style.setProperty('display', 'none', 'important');
        facetsWrap.style.setProperty('visibility', 'hidden', 'important');
        facetsWrap.style.setProperty('opacity', '0', 'important');
        facetsWrap.style.setProperty('pointer-events', 'none', 'important');
      } else {
        facetsWrap.classList.remove('facets-wrapper--drawer-suppressed');
        facetsWrap.style.removeProperty('display');
        facetsWrap.style.removeProperty('visibility');
        facetsWrap.style.removeProperty('opacity');
        facetsWrap.style.removeProperty('pointer-events');
      }
    }
  };

  CollectionBandConfigurator.prototype._getRefineDetails = function () {
    return document.querySelector('.mobile-facets__wrapper details.mobile-facets__disclosure') ||
      document.querySelector('.mobile-facets__wrapper details.disclosure-has-popup');
  };

  CollectionBandConfigurator.prototype._getVisibleHeaderBottom = function () {
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return 0;
    var selectors = [
      '.section-header.shopify-section-group-header-group',
      '.shopify-section-group-header-group.section-header',
      '#shopify-section-header',
      'sticky-header',
      'header.header',
      '.announcement-bar-section',
      '.announcement-bar'
    ];
    var bottom = 0;
    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (!el || !el.getBoundingClientRect) return;
        var style = window.getComputedStyle ? window.getComputedStyle(el) : null;
        if (style && (style.display === 'none' || style.visibility === 'hidden')) return;
        var rect = el.getBoundingClientRect();
        if (rect.width < 1 || rect.height < 1) return;
        if (rect.bottom <= 0 || rect.top > 140) return;
        bottom = Math.max(bottom, rect.bottom);
      });
    });
    // V43: do not invent a header offset when the real header is not visible.
    // The collection Studio and Filter surfaces should open from the current
    // viewport position without scrolling the customer back to the top.
    if (!bottom || bottom < 1) return 0;
    return Math.max(0, Math.min(Math.round(bottom), 128));
  };

  CollectionBandConfigurator.prototype._getStickyHeaderElement = function () {
    return document.querySelector('sticky-header');
  };

  CollectionBandConfigurator.prototype._getSurfaceHeader = function () {
    var stickyHeader = this._getStickyHeaderElement ? this._getStickyHeaderElement() : document.querySelector('sticky-header');
    return (stickyHeader && stickyHeader.closest('.section-header')) ||
      document.querySelector('.section-header') ||
      document.querySelector('#shopify-section-header');
  };

  CollectionBandConfigurator.prototype._syncNativeSurfaceOffset = function () {
    var offset = 0;

    if (this._isMobileCollectionSurface && this._isMobileCollectionSurface() &&
        document.body.classList.contains('studio-collection-surface-header-fixed')) {
      var header = this._getSurfaceHeader ? this._getSurfaceHeader() : document.querySelector('.section-header');
      if (header) {
        var rect = header.getBoundingClientRect ? header.getBoundingClientRect() : null;
        offset = Math.round((rect && rect.height) || header.offsetHeight || 0);
      }
    } else {
      offset = this._getVisibleHeaderBottom ? this._getVisibleHeaderBottom() : 0;
    }

    document.documentElement.style.setProperty('--studio-collection-panel-offset', Math.max(0, offset) + 'px');
  };

  CollectionBandConfigurator.prototype._isMobileCollectionSurface = function () {
    return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  };

  CollectionBandConfigurator.prototype._revealMobileSurfaceHeader = function () {
    if (!this._isMobileCollectionSurface || !this._isMobileCollectionSurface()) return;
    var header = this._getSurfaceHeader ? this._getSurfaceHeader() : document.querySelector('.section-header');
    var stickyHeader = this._getStickyHeaderElement ? this._getStickyHeaderElement() : document.querySelector('sticky-header');
    if (!header) return;

    if (!this._mobileSurfaceHeaderState || this._mobileSurfaceHeaderState.header !== header) {
      this._mobileSurfaceHeaderState = {
        header: header,
        stickyHeader: stickyHeader,
        hadSticky: header.classList.contains('shopify-section-header-sticky'),
        hadHidden: header.classList.contains('shopify-section-header-hidden'),
        hadAnimate: header.classList.contains('animate'),
        hadSurfaceFixed: document.body.classList.contains('studio-collection-surface-header-fixed'),
        stickyPreventHide: stickyHeader ? stickyHeader.preventHide : undefined
      };
    }

    if (stickyHeader) {
      stickyHeader.preventHide = true;
      if (typeof stickyHeader.reveal === 'function') stickyHeader.reveal();
    }

    document.body.classList.add('studio-collection-surface-header-open', 'studio-collection-surface-header-fixed');
    header.classList.remove('shopify-section-header-hidden');
    header.classList.add('shopify-section-header-sticky', 'animate', 'studio-collection-surface-header');
  };

  CollectionBandConfigurator.prototype._releaseMobileSurfaceHeader = function () {
    if (!this._mobileSurfaceHeaderState) return;
    if (document.body.classList.contains('studio-collection-open') ||
        document.body.classList.contains('studio-collection-refine-open')) return;

    var state = this._mobileSurfaceHeaderState;
    var header = state.header;
    if (state.stickyHeader && state.stickyPreventHide !== undefined) {
      state.stickyHeader.preventHide = state.stickyPreventHide;
    }
    if (header) {
      header.classList.remove('studio-collection-surface-header');
      if (!state.hadAnimate) header.classList.remove('animate');
      if (!state.hadSticky) header.classList.remove('shopify-section-header-sticky');
      if (state.hadHidden) header.classList.add('shopify-section-header-hidden');
      else header.classList.remove('shopify-section-header-hidden');
    }
    document.body.classList.remove('studio-collection-surface-header-open');
    if (!state.hadSurfaceFixed) document.body.classList.remove('studio-collection-surface-header-fixed');
    this._mobileSurfaceHeaderState = null;
    if (this._syncNativeSurfaceOffset) this._syncNativeSurfaceOffset();
  };

  CollectionBandConfigurator.prototype._prepareMobileCollectionSurface = function () {
    if (!this._isMobileCollectionSurface || !this._isMobileCollectionSurface()) return;

    // V45: no scroll-to-top. Reveal/pin the native header if needed, calculate the
    // drawer offset immediately, then refresh once after layout has applied.
    if (this._revealMobileSurfaceHeader) this._revealMobileSurfaceHeader();
    if (this._syncNativeSurfaceOffset) this._syncNativeSurfaceOffset();
    var self = this;
    window.requestAnimationFrame(function () {
      if (self._syncNativeSurfaceOffset) self._syncNativeSurfaceOffset();
    });
  };

  CollectionBandConfigurator.prototype._ensureRefineCloseButton = function () {
    var details = this._getRefineDetails();
    if (!details) return;
    var surface = details.querySelector('.mobile-facets');
    var inner = details.querySelector('.mobile-facets__inner');
    if (surface) {
      surface.classList.add(
        'studio-collection__drawer',
        'studio-collection__drawer--below-header',
        'studio-collection__drawer--refine'
      );
    }
    if (inner) {
      inner.classList.add('studio-collection__panel');
    }

    // V40: do not inject a second Filter / Sort header or close button.
    // The Shopify mobile facets header stays as the only internal title,
    // and the shared hamburger acts as the visible close control on mobile.
    details.querySelectorAll('[data-studio-refine-head]').forEach(function (el) { el.remove(); });
  };

  CollectionBandConfigurator.prototype._openRefineDrawer = function () {
    this._closeDrawer();
    if (this._prepareMobileCollectionSurface) this._prepareMobileCollectionSurface();
    else this._syncNativeSurfaceOffset();
    this._ensureRefineCloseButton();
    var details = this._getRefineDetails();
    if (!details) return;
    var summary = details.querySelector('summary');
    var isOpen = details.hasAttribute('open') || details.classList.contains('menu-opening') ||
      document.body.classList.contains('studio-collection-refine-open');
    if (isOpen) {
      this._closeRefineDrawer();
      return;
    }
    if (summary) summary.click();
    if (!details.hasAttribute('open')) details.setAttribute('open', '');
    if (!details.classList.contains('menu-opening')) details.classList.add('menu-opening');
    document.body.classList.add('studio-collection-refine-open');
    document.documentElement.classList.add('studio-collection-surface-lock');
    setSharedHeaderCloseState(true);
    if (this.refineTrigger) { this.refineTrigger.classList.add('is-active'); this.refineTrigger.setAttribute('aria-expanded', 'true'); }
    if (this.toolbarTrigger) { this.toolbarTrigger.classList.remove('is-active'); this.toolbarTrigger.setAttribute('aria-expanded', 'false'); }
    this._syncMobileToolbarVisibility();
  };

  CollectionBandConfigurator.prototype._closeRefineDrawer = function () {
    var details = this._getRefineDetails();
    if (details && (details.hasAttribute('open') || details.classList.contains('menu-opening'))) {
      var summary = details.querySelector('summary');
      if (summary) summary.click();
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
    }
    document.body.classList.remove('studio-collection-refine-open');
    if (!document.body.classList.contains('studio-collection-open')) document.documentElement.classList.remove('studio-collection-surface-lock');
    if (!document.body.classList.contains('studio-collection-open')) setSharedHeaderCloseState(false);
    if (this.refineTrigger) { this.refineTrigger.classList.remove('is-active'); this.refineTrigger.setAttribute('aria-expanded', 'false'); }
    this._cleanupNativeDrawerLock();
    if (this._releaseMobileSurfaceHeader) this._releaseMobileSurfaceHeader();
    this._syncMobileToolbarVisibility();
  };




  CollectionBandConfigurator.prototype._cleanupNativeDrawerLock = function () {
    if (document.body.classList.contains('studio-collection-open') || document.body.classList.contains('studio-collection-refine-open')) return;
    document.documentElement.classList.remove('studio-collection-surface-lock');
    document.body.classList.remove('studio-collection-mobile-drawer-open');
  };

  CollectionBandConfigurator.prototype._syncExternalDrawerState = function () {
    // Stage 5A V9: native menu/cart must win by stacking order, not by hiding the Studio toolbar.
    // We only close open collection surfaces so there are never two active drawers.
    var candidates = Array.prototype.slice.call(document.querySelectorAll('#Details-menu-drawer-container[open], header-drawer details[open].menu-opening'));
    var menuOpen = candidates.some(function (el) {
      if (!el || !el.getBoundingClientRect) return false;
      var style = window.getComputedStyle ? window.getComputedStyle(el) : null;
      if (style && (style.display === 'none' || style.visibility === 'hidden')) return false;
      var rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });
    var cartOpen = !!document.querySelector('cart-drawer.active, .cart-drawer.active, .drawer.active');
    if (menuOpen || cartOpen) {
      this._closeDrawer();
      this._closeRefineDrawer();
    }
  };

  CollectionBandConfigurator.prototype._bindUi = function () {
    var self = this;
    document.addEventListener('toggle', function (ev) {
      if (ev && ev.target && ev.target.matches && ev.target.matches('#Details-menu-drawer-container, header-drawer details')) {
        self._syncExternalDrawerState();
      }
      if (ev && ev.target && ev.target.matches && ev.target.matches('.mobile-facets__disclosure')) {
        if (ev.target.hasAttribute('open')) {
          if (self._prepareMobileCollectionSurface) self._prepareMobileCollectionSurface();
          else if (self._syncNativeSurfaceOffset) self._syncNativeSurfaceOffset();
          self._ensureRefineCloseButton();
          document.body.classList.add('studio-collection-refine-open');
          document.documentElement.classList.add('studio-collection-surface-lock');
          setSharedHeaderCloseState(true);
        } else {
          ev.target.classList.remove('menu-opening');
          document.body.classList.remove('studio-collection-refine-open');
          if (!document.body.classList.contains('studio-collection-open')) document.documentElement.classList.remove('studio-collection-surface-lock');
          if (!document.body.classList.contains('studio-collection-open')) setSharedHeaderCloseState(false);
          if (self.refineTrigger) {
            self.refineTrigger.classList.remove('is-active');
            self.refineTrigger.setAttribute('aria-expanded', 'false');
          }
          if (self._cleanupNativeDrawerLock) self._cleanupNativeDrawerLock();
          if (self._releaseMobileSurfaceHeader) self._releaseMobileSurfaceHeader();
          self._syncMobileToolbarVisibility();
        }
      }
    }, true);
    document.addEventListener('click', function () {
      setTimeout(function () { self._syncExternalDrawerState(); }, 0);
    }, true);
    var openBtns = this.root.querySelectorAll('[data-b1-coll-open]');
    var closeBtns = this.root.querySelectorAll('[data-b1-coll-close]');

    openBtns.forEach(function (openBtn) {
      openBtn.addEventListener('click', function () {
        self._openDrawer();
      });
    });
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self._closeDrawer();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      self._closeDrawer();
      self._closeRefineDrawer();
    });

    this.root.querySelectorAll('[data-studio-collection-device-size]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self._selectSize(btn.getAttribute('data-device-size'));
      });
    });

    this.root.querySelectorAll('[data-studio-collection-royal-model]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self._selectRoyalModel(Number(btn.getAttribute('data-model-index')));
      });
    });


    var frameTypeRow = this.root.querySelector('[data-b1-coll-frame-types]');
    if (frameTypeRow) {
      frameTypeRow.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-b1-coll-frame-type-btn]');
        if (!btn) return;
        self._selectFrameType(Number(btn.getAttribute('data-frame-index')) || 0);
      });
    }

    var finishRow = this.root.querySelector('[data-b1-coll-finish]');
    if (finishRow) {
      finishRow.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-b1-coll-finish-btn]');
        if (!btn) return;
        self._selectFinish(btn.getAttribute('data-finish'));
      });
    }

    this.root.querySelectorAll('[data-b1-coll-mode]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self._setMode(btn.getAttribute('data-b1-coll-mode'));
      });
    });

    var wwLines = this.root.querySelector('[data-b1-coll-ww-lines]');
    if (wwLines) {
      wwLines.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-b1-coll-ww-line-btn]');
        if (!btn) return;
        self._selectWatchWareLine(btn.getAttribute('data-line'));
      });
    }

    var wwColors = this.root.querySelector('[data-studio-collection-ww-colors]');
    if (wwColors) {
      wwColors.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-b1-coll-ww-finish-btn]');
        if (!btn) return;
        var idx = parseInt(btn.getAttribute('data-entry-index'), 10);
        if (!isNaN(idx)) self._selectWatchWareFinish(idx);
      });
    }

    var resetBtn = this.root.querySelector('[data-b1-coll-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self._resetConfiguration();
      });
    }
  };

  CollectionBandConfigurator.prototype._resetConfiguration = function () {
    if (this.isRoyal) return;

    var next = buildConfigUrl(window.location.pathname, null, true);
    var current = window.location.pathname + window.location.search + window.location.hash;
    if (next !== current) {
      history.replaceState({}, '', next);
    }

    this.isConfigured = false;
    this.mode = 'direct';
    document.documentElement.classList.remove('studio-collection--configured');
    document.documentElement.classList.remove('b1-coll-band--watchware');

    this.bandModule.state.deviceSize = null;
    this.bandModule.state.linkFinish = null;
    if (this.watchWareModule) {
      this.watchWareModule._initDefaults();
    }

    this._applyModeUi();
    this._renderSizeButtons();
    this._renderFinishButtons();
    if (this.hasWatchWare) this._renderWatchWareControls();
    this._updateAllCardPreviews(false);
    this._updateProductLinks();
    this._updateBottomSummary();
    this._closeDrawer();
  };

  CollectionBandConfigurator.prototype._setMode = function (mode) {
    if (mode !== 'watchware' && mode !== 'direct') return;
    if (mode === 'watchware' && !this.hasWatchWare) return;
    this.mode = mode;
    this._applyModeUi();
    var startGroup = window.BrilintonStudioFlow && window.BrilintonStudioFlow.collectionModeStart ? window.BrilintonStudioFlow.collectionModeStart(this) : (mode === 'watchware' ? 'watchware' : (this.isRoyal ? 'royal-model' : 'apple-size'));
    this._openCollectionGroup(startGroup);
    if (mode === 'watchware' && this.watchWareModule && this.watchWareModule.getSelectedEntry()) {
      this._commitConfiguration(false);
    } else if (!this.isRoyal && this.mode === 'direct' && this.bandModule.state.deviceSize) {
      this._commitConfiguration(false);
    } else if (this.isConfigured) {
      this._enhanceProductCards();
      this._updateAllCardPreviews(true);
      this._updateProductLinks();
      this._syncUrl(false);
    }
  };

  CollectionBandConfigurator.prototype._applyModeUi = function () {
    var isWw = this.mode === 'watchware';
    this.root.classList.toggle('b1-coll-band--mode-watchware', isWw);
    this.root.classList.toggle('b1-coll-band--mode-direct', !isWw);

    if (this.panelDirect) { this.panelDirect.classList.toggle('is-hidden', isWw); this.panelDirect.hidden = !!isWw; }
    if (this.panelWatchware) { this.panelWatchware.classList.toggle('is-hidden', !isWw); this.panelWatchware.hidden = !isWw; }

    this.root.querySelectorAll('[data-b1-coll-mode]').forEach(
      function (btn) {
        var active = btn.getAttribute('data-b1-coll-mode') === this.mode;
        btn.classList.toggle('is-active', active);
        btn.classList.toggle('is-selected', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      }.bind(this)
    );
    this._syncStudioSummaryValues();

    document.documentElement.classList.toggle('b1-coll-band--watchware', isWw && this.isConfigured);
    this._updateBottomSummary();
  };


  CollectionBandConfigurator.prototype._isMobileCollectionSurface = function () {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  };

  CollectionBandConfigurator.prototype._getVisibleCollectionGroups = function () {
    if (!this.drawer) return [];
    return Array.prototype.slice.call(this.drawer.querySelectorAll('.studio__group')).filter(function (group) {
      return !!(group.offsetWidth || group.offsetHeight || group.getClientRects().length);
    });
  };


  CollectionBandConfigurator.prototype._setCollectionGroupOpen = function (group, open) {
    if (!group) return;
    group.classList.toggle('is-open', !!open);
    group.setAttribute('data-open', open ? 'true' : 'false');
    var summary = group.querySelector('[data-studio-summary], .studio__summary');
    var options = group.querySelector('[data-studio-options], .studio__options');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (options) {
      if (open) options.removeAttribute('hidden');
      else options.setAttribute('hidden', '');
    }
  };

  CollectionBandConfigurator.prototype._openCollectionGroup = function (groupId) {
    var self = this;
    if (!this.drawer || !groupId) return;
    var target = this.drawer.querySelector('[data-studio-group-id="' + groupId + '"]');
    if (!target) return;
    this._getVisibleCollectionGroups().forEach(function (group) {
      self._setCollectionGroupOpen ? self._setCollectionGroupOpen(group, group === target) : group.classList.toggle('is-open', group === target);
    });
    var panel = this.drawer.querySelector('.studio__body');
    if (panel && target && typeof target.offsetTop === 'number') panel.scrollTo({ top: Math.max(0, target.offsetTop - 8), behavior: 'smooth' });
  };

  CollectionBandConfigurator.prototype._syncCollectionAccordions = function () {
    var self = this;
    var groups = this._getVisibleCollectionGroups();
    if (!groups.length) return;
    var preferred = this.mode === 'watchware'
      ? 'watchware'
      : (this.isRoyal ? 'royal-model' : (this.bandModule && this.bandModule.state && this.bandModule.state.deviceSize ? 'link' : 'connection'));
    var open = groups.find(function (group) { return group.classList.contains('is-open'); }) ||
      groups.find(function (group) { return group.getAttribute('data-studio-group-id') === preferred; }) ||
      groups.find(function (group) { return group.getAttribute('data-studio-group-id') === 'connection'; }) ||
      groups[0];
    groups.forEach(function (group) { self._setCollectionGroupOpen(group, group === open); });
  };

  CollectionBandConfigurator.prototype._bindCollectionAccordions = function () {
    if (!this.drawer || this._collectionAccordionsBound) return;
    this._collectionAccordionsBound = true;
    var self = this;
    this.drawer.querySelectorAll('[data-studio-summary], .studio__summary, .studio__group-label').forEach(function (label) {
      if (!label.matches('button')) { label.setAttribute('role', 'button'); label.setAttribute('tabindex', '0'); }
      function toggle(e) {
        e.preventDefault();
        var group = label.closest('.studio__group');
        if (!group) return;
        self._getVisibleCollectionGroups().forEach(function (candidate) {
          self._setCollectionGroupOpen(candidate, candidate === group);
        });
      }
      label.addEventListener('click', toggle);
      label.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') toggle(e);
      });
    });
    window.addEventListener('resize', function () { self._syncCollectionAccordions(); self._syncNativeSurfaceOffset(); self._syncMobileToolbarVisibility(); });
    this._syncCollectionAccordions();
  };

  CollectionBandConfigurator.prototype._openDrawer = function () {
    this._closeRefineDrawer();
    if (window.BrilintonSurfaceManager) {
      var self = this;
      window.BrilintonSurfaceManager.register('collection-studio', {
        root: function () { return self.drawer; },
        close: function () { self._closeDrawer(); },
      });
      window.BrilintonSurfaceManager.open('collection-studio', {
        trigger: this.toolbarTrigger || this.floatingTrigger || document.activeElement,
        lockMode: 'overflow',
      });
    }
    var isMobileSurface = this._isMobileCollectionSurface && this._isMobileCollectionSurface();
    if (isMobileSurface && this._prepareMobileCollectionSurface) {
      this._prepareMobileCollectionSurface();
    } else {
      this._syncNativeSurfaceOffset();
    }
    if (this.drawer) {
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('studio-collection-open');
      document.documentElement.classList.add('studio-collection-surface-lock');
      if (this.floatingTrigger) this.floatingTrigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('b1-coll-band-bottom-open');
      document.body.classList.add('studio-collection-preview-open');
      if (this.root) this.root.classList.add('studio-collection--open');
      if (this.toolbarTrigger) { this.toolbarTrigger.classList.add('is-active'); this.toolbarTrigger.setAttribute('aria-expanded', 'true'); }
      try { window.sessionStorage.setItem('studioCollectionPreviewSeen', '1'); } catch (e) {}
      if (this.toolbarTrigger) {
        var mark = this.toolbarTrigger.querySelector('.studio-collection__coachmark');
        if (mark) mark.remove();
      }
      this._openCollectionGroup('connection');
      this._syncCollectionAccordions();
      this._syncMobileToolbarVisibility();
    }
  };

  CollectionBandConfigurator.prototype._closeDrawer = function () {
    if (this.drawer) {
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('studio-collection-open');
      document.documentElement.classList.remove('studio-collection-surface-lock');
      if (this.floatingTrigger) this.floatingTrigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('b1-coll-band-bottom-open');
      document.body.classList.remove('studio-collection-preview-open');
      document.body.classList.remove('studio-collection-native-drawer-open');
      if (this.root) this.root.classList.remove('studio-collection--open');
      if (this.toolbarTrigger) { this.toolbarTrigger.classList.remove('is-active'); this.toolbarTrigger.setAttribute('aria-expanded', 'false'); }
      if (this._cleanupNativeDrawerLock) this._cleanupNativeDrawerLock();
      if (this._releaseMobileSurfaceHeader) this._releaseMobileSurfaceHeader();
    }
    if (window.BrilintonSurfaceManager) {
      window.BrilintonSurfaceManager.close('collection-studio', { restoreFocus: true });
    }
    this._syncMobileToolbarVisibility();
  };

  CollectionBandConfigurator.prototype._coerceLinkFinishForSize = function () {
    var finishes = this.bandModule.getAvailableFinishes();
    if ((!finishes || !finishes.length) && !this.isRoyal && this.bandModule && this.bandModule.bLink && this.bandModule.bLink.variants) {
      var seenFallbackFinish = {};
      var liFallback = this.bandModule.linkOptionIdx || { size: 0, finish: 1 };
      finishes = [];
      this.bandModule.bLink.variants.forEach(function (v) {
        var f = optByIndexLocal(v, liFallback.finish);
        if (!f || seenFallbackFinish[normLocal(f)]) return;
        seenFallbackFinish[normLocal(f)] = true;
        finishes.push(f);
      });
    }
    if (!finishes || !finishes.length) {
      this.bandModule.state.linkFinish = null;
      return;
    }
    var cur = this.bandModule.state.linkFinish;
    var matched = false;
    if (cur) {
      for (var i = 0; i < finishes.length; i++) {
        if (this.norm(finishes[i]) === this.norm(cur)) {
          matched = true;
          break;
        }
      }
    }
    if (!matched) this.bandModule.state.linkFinish = finishes[0];
  };


  CollectionBandConfigurator.prototype._renderFrameTypeButtons = function () {
    var row = this.root.querySelector('[data-b1-coll-frame-types]');
    if (!row) return;
    var frames = this.bandModule && this.bandModule.getFrameEntries ? this.bandModule.getFrameEntries() : [];
    row.innerHTML = '';
    var label = row.previousElementSibling;
    if (!this.isRoyal || !frames.length) { row.hidden = true; if (label) label.hidden = true; return; }
    row.hidden = false;
    if (label) {
      label.hidden = true;
      label.style.display = 'none';
    }
    var self = this;
    frames.forEach(function (frame, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'studio__option' +
        (Number(self.bandModule.state.frameIndex || 0) === i ? ' is-active is-selected' : '');
      var frameLabel = frame.finish || frame.type || frame.title || ('Frame ' + (i + 1));
      btn.setAttribute('data-b1-coll-frame-type-btn', '');
      btn.setAttribute('data-studio-option', '');
      btn.setAttribute('data-option-name', 'frameType');
      btn.setAttribute('data-option-value', frameLabel);
      btn.setAttribute('data-frame-index', String(i));
      btn.setAttribute('aria-selected', Number(self.bandModule.state.frameIndex || 0) === i ? 'true' : 'false');
      btn.textContent = frameLabel;
      row.appendChild(btn);
    });
  };

  CollectionBandConfigurator.prototype._renderFinishButtons = function () {
    var row = this.root.querySelector('[data-b1-coll-finish]');
    if (!row) return;

    var labelEl = row.previousElementSibling;
    if (this.isRoyal) {
      var royalFinishes = this.bandModule.getAvailableFinishes ? this.bandModule.getAvailableFinishes() : [];
      if (royalFinishes && royalFinishes.length) this.bandModule.state.linkFinish = royalFinishes[0];
      row.innerHTML = '';
      row.hidden = true;
      row.style.display = 'none';
      if (labelEl) {
        labelEl.hidden = true;
        labelEl.style.display = 'none';
      }
      return;
    }

    if (!this.isRoyal && this.bandModule && this.bandModule.state && this.bandModule.state.deviceSize) {
      this._coerceLinkFinishForSize();
    }

    var finishes = this.bandModule.getAvailableFinishes();
    if ((!finishes || !finishes.length) && !this.isRoyal && this.bandModule && this.bandModule.bLink && this.bandModule.bLink.variants) {
      var seenFallbackFinish = {};
      var liFallback = this.bandModule.linkOptionIdx || { size: 0, finish: 1 };
      finishes = [];
      this.bandModule.bLink.variants.forEach(function (v) {
        var f = optByIndexLocal(v, liFallback.finish);
        if (!f || seenFallbackFinish[normLocal(f)]) return;
        seenFallbackFinish[normLocal(f)] = true;
        finishes.push(f);
      });
    }
    if (finishes && finishes.length && (!this.bandModule.state.linkFinish || !finishes.some(function (f) { return this.norm(f) === this.norm(this.bandModule.state.linkFinish); }, this))) {
      this.bandModule.state.linkFinish = finishes[0];
    }
    var hasMeaningfulFinish = finishes && finishes.length > 0;

    row.innerHTML = '';
    row.hidden = !hasMeaningfulFinish;
    row.style.display = hasMeaningfulFinish ? '' : 'none';
    if (labelEl) {
      labelEl.hidden = !hasMeaningfulFinish;
      labelEl.style.display = hasMeaningfulFinish ? '' : 'none';
    }
    if (!hasMeaningfulFinish) return;

    var self = this;
    finishes.forEach(function (f) {
      var btn = document.createElement('button');
      btn.type = 'button';
      var active = self.norm(f) === self.norm(self.bandModule.state.linkFinish);
      btn.className =
        'studio__option' +
        (active ? ' is-active is-selected' : '');
      btn.setAttribute('data-b1-coll-finish-btn', '');
      btn.setAttribute('data-studio-option', '');
      btn.setAttribute('data-option-name', 'frameFinish');
      btn.setAttribute('data-option-value', f);
      btn.setAttribute('data-finish', f);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
      btn.textContent = f;
      row.appendChild(btn);
    });
  };

  CollectionBandConfigurator.prototype._renderImageSwatchCards = function (container, entries, options) {
    if (!container) return;
    options = options || {};
    var selEntry = options.selectedEntry;
    var clickAttr = options.clickAttr || 'data-b1-coll-ww-finish-btn';
    var seenFinish = {};
    var norm = this.norm;
    container.innerHTML = '';
    entries.forEach(function (entry) {
      var label = entry.finish || '';
      if (!label) return;
      var finKey = entry.finish || '';
      if (!finKey || seenFinish[norm(finKey)]) return;
      seenFinish[norm(finKey)] = true;
      var isSelected = !!(selEntry && norm(selEntry.finish) === norm(finKey));
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'studio-card studio-card--watchware' +
        (isSelected ? ' is-active is-selected' : '');
      btn.setAttribute('data-studio-option', '');
      btn.setAttribute('data-option-name', 'watchwareFinish');
      btn.setAttribute('data-option-value', finKey);
      btn.setAttribute('data-summary-primary', (window.B1PreviewKit && window.B1PreviewKit.watchwareLineOptionLabel) ? window.B1PreviewKit.watchwareLineOptionLabel(entry.line || entry.lineName || '') : (entry.line || entry.lineName || 'WatchWare'));
      btn.setAttribute('data-summary-secondary', finKey);
      btn.setAttribute(clickAttr, '');
      btn.setAttribute('data-entry-index', String(entry.index));
      btn.setAttribute('data-finish', finKey);
      var imgSrc = entry.swatchImage || entry.thumb || entry.watchView || entry.topBand || '';
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
      btn.setAttribute('data-studio-option-card', '');
      var media = document.createElement('span');
      media.className = 'studio-card__media';
      if (imgSrc) {
        var img = document.createElement('img');
        img.className = 'studio-card__image';
        img.src = imgSrc;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 120;
        img.height = 120;
        media.appendChild(img);
      } else {
        var fallback = document.createElement('span');
        fallback.className = 'studio-card__fallback';
        fallback.setAttribute('aria-hidden', 'true');
        media.appendChild(fallback);
      }
      btn.appendChild(media);
      var span = document.createElement('span');
      span.className = 'studio-card__title';
      span.textContent = label;
      btn.appendChild(span);
      container.appendChild(btn);
    });
  };

  CollectionBandConfigurator.prototype._renderWatchWareControls = function () {
    if (!this.watchWareModule) return;
    var linesEl = this.root.querySelector('[data-b1-coll-ww-lines]');
    var colorsEl = this.root.querySelector('[data-studio-collection-ww-colors]');
    if (!linesEl || !colorsEl) return;

    var lines = this.watchWareModule.getUniqueLines();
    linesEl.innerHTML = '';
    var self = this;
    lines.forEach(function (line) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'studio__option' +
        (self.norm(line) === self.norm(self.watchWareModule.state.line) ? ' is-active is-selected' : '');
      var lineLabel = (self.kit && self.kit.watchwareLineOptionLabel) ? self.kit.watchwareLineOptionLabel(line) : line;
      btn.setAttribute('data-b1-coll-ww-line-btn', '');
      btn.setAttribute('data-studio-option', '');
      btn.setAttribute('data-option-name', 'watchwareLine-' + (self.isRoyal ? 'royal' : 'apple'));
      btn.setAttribute('data-option-value', line);
      btn.setAttribute('data-summary-line-label', lineLabel);
      btn.setAttribute('data-line', line);
      btn.setAttribute('aria-selected', self.norm(line) === self.norm(self.watchWareModule.state.line) ? 'true' : 'false');
      btn.textContent = lineLabel;
      linesEl.appendChild(btn);
    });
    var lineLabel = linesEl.previousElementSibling;
    var showLines = lines.length > 1;
    linesEl.hidden = !showLines;
    if (lineLabel) lineLabel.hidden = !showLines;

    var lineEntries = this.watchWareModule.getEntriesForLine(this.watchWareModule.state.line);
    this._renderImageSwatchCards(colorsEl, lineEntries, {
      selectedEntry: this.watchWareModule.getSelectedEntry(),
    });
  };

  CollectionBandConfigurator.prototype._renderRoyalModelButtons = function () {
    var self = this;
    this.root.querySelectorAll('[data-studio-collection-royal-model]').forEach(function (btn) {
      var selected = Number(btn.getAttribute('data-model-index')) === self.bandModule.state.modelIndex;
      btn.classList.remove('is-active');
      btn.classList.toggle('is-selected', selected);
      btn.setAttribute('aria-selected', selected ? 'true' : 'false');
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  };

  CollectionBandConfigurator.prototype._renderSizeButtons = function () {
    var self = this;
    this.root.querySelectorAll('[data-studio-collection-device-size]').forEach(function (btn) {
      var selected = btn.getAttribute('data-device-size') === self.bandModule.state.deviceSize;
      btn.classList.remove('is-active');
      btn.classList.toggle('is-selected', selected);
      btn.setAttribute('aria-selected', selected ? 'true' : 'false');
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  };

  CollectionBandConfigurator.prototype._updateBottomSummary = function () {
    var sectionId = this.root && this.root.getAttribute('data-b1-coll-band-section');
    var els = [];
    if (this.root) {
      els = els.concat(Array.prototype.slice.call(this.root.querySelectorAll('[data-b1-coll-summary]')));
    }
    if (sectionId) {
      els = els.concat(Array.prototype.slice.call(document.querySelectorAll('[data-studio-collection-toolbar-trigger][data-b1-coll-section-id="' + sectionId + '"] [data-b1-coll-summary]')));
    }
    if (!els.length) return;
    var parts = [];
    if (this.isRoyal) {
      parts.push('Royal Pop');
    } else {
      parts.push('Apple Watch');
      if (this.bandModule && this.bandModule.state && this.bandModule.state.deviceSize) parts.push(this.bandModule.state.deviceSize);
    }
    parts.push(this.mode === 'watchware' ? 'WatchWare' : 'Direct');
    if (this.mode === 'watchware' && this.watchWareModule) {
      var entry = this.watchWareModule.getSelectedEntry && this.watchWareModule.getSelectedEntry();
      if (entry) {
        var line = (this.kit && this.kit.watchwareLineOptionLabel) ? this.kit.watchwareLineOptionLabel(entry.line || entry.lineName || '') : (entry.line || '');
        var finish = entry.finish || '';
        if (line) parts.push(line);
        if (finish) parts.push(finish);
      }
    }
    var summary = parts.filter(Boolean).join(' / ') || 'Choose your device setup';
    els.forEach(function (el) { el.textContent = summary; });
    if (this._syncStudioSummaryValues) this._syncStudioSummaryValues();
  };



  CollectionBandConfigurator.prototype._syncStudioSummaryValues = function () {
    if (!this.root) return;
    var set = function (key, value) {
      var el = this.root.querySelector('[data-summary-value="' + key + '"]');
      if (el) el.textContent = value || '';
    }.bind(this);
    var pairingDevice = this.isRoyal ? 'Royal Pop' : 'Apple Watch';
    var pairingMode = this.mode === 'watchware' ? 'WatchWare' : 'Direct';
    set('pairing', pairingDevice + ' / ' + pairingMode);
    if (!this.isRoyal) set('apple-size', this.bandModule && this.bandModule.state && this.bandModule.state.deviceSize ? this.bandModule.state.deviceSize : '');
    if (!this.isRoyal) set('link', this.bandModule && this.bandModule.state && this.bandModule.state.linkFinish ? this.bandModule.state.linkFinish : '');
    if (this.isRoyal && this.bandModule) {
      var royalModel = this.bandModule.getRoyalModel ? this.bandModule.getRoyalModel() : null;
      set('royal-model', royalModel ? (royalModel.name || royalModel.model_name || '') : '');
      var frame = this.bandModule.getSelectedFrame ? this.bandModule.getSelectedFrame() : null;
      var frameLabel = frame ? (frame.finish || frame.type || frame.title || frame.productTitle || '') : '';
      var finishLabel = this.bandModule.state && this.bandModule.state.linkFinish ? this.bandModule.state.linkFinish : '';
      set('frame', frameLabel || finishLabel || '');
    }
    if (this.watchWareModule && this.root.querySelector('[data-summary-value="watchware"]')) {
      var entry = this.watchWareModule.getSelectedEntry && this.watchWareModule.getSelectedEntry();
      var label = '';
      if (entry) {
        var line = (this.kit && this.kit.watchwareLineOptionLabel) ? this.kit.watchwareLineOptionLabel(entry.line || entry.lineName || '') : (entry.line || '');
        var finish = entry.finish || '';
        label = [line, finish].filter(Boolean).join(' / ') || '';
      }
      set('watchware', label);
    }
  };

  CollectionBandConfigurator.prototype._getUrlConfig = function () {
    var P = this.urlP;
    var device = this.kit.deviceSlugFromPlatform(this.platform);
    if (this.mode === 'watchware' && this.hasWatchWare) {
      var entry = this.watchWareModule.getSelectedEntry();
      var wwParams = entry && this.kit.watchwareParamsFromEntry
        ? this.kit.watchwareParamsFromEntry(entry)
        : { line: null, finish: null };
      var cfg = {
        platform: this.platform,
        device: device,
        mode: 'watchware',
        watchware: entry && this.kit.watchwareSlugFromEntry ? this.kit.watchwareSlugFromEntry(entry) : null,
        line: wwParams.line,
        finish: wwParams.finish,
      };
      if (this.isRoyal && this.bandModule.state.modelIndex != null) {
        cfg.model = this.bandModule.state.modelIndex;
      }
      return cfg;
    }
    if (this.isRoyal) {
      var selectedFrame = this.bandModule.getSelectedFrame ? this.bandModule.getSelectedFrame() : null;
      return {
        platform: 'royal',
        device: device,
        mode: this.mode,
        model: this.bandModule.state.modelIndex,
        frameType: selectedFrame ? (selectedFrame.type || selectedFrame.title || selectedFrame.productTitle || '') : null,
        frameFinish: this.isConfigured ? this.bandModule.state.linkFinish : null,
        frame: this.isConfigured ? this.bandModule.state.linkFinish : null,
      };
    }
    return {
      platform: 'apple',
      device: device,
      mode: this.mode,
      size: this.bandModule.state.deviceSize,
      link: this.isConfigured ? this.bandModule.state.linkFinish : null,
    };
  };

  CollectionBandConfigurator.prototype._syncUrl = function (replace) {
    if (!this.isConfigured) return;
    var next = buildConfigUrl(window.location.pathname, this._getUrlConfig(), true);
    var current = window.location.pathname + window.location.search + window.location.hash;
    if (next === current) return;
    var state = { b1CollBand: this._getUrlConfig() };
    if (replace) history.replaceState(state, '', next);
    else history.pushState(state, '', next);
  };

  CollectionBandConfigurator.prototype._handlePopState = function () {
    this._applyFromUrl(true);
  };

  CollectionBandConfigurator.prototype._resolveModeFromParams = function (params) {
    return this.kit.resolveModeFromParams(params, {
      hasWatchWare: this.hasWatchWare,
      isRoyal: this.isRoyal,
    });
  };

  CollectionBandConfigurator.prototype._applyFromUrl = function (replaceHistory) {
    var P = this.urlP;
    var params = new URLSearchParams(window.location.search);
    var resolvedMode = this._resolveModeFromParams(params);

    if (!resolvedMode) {
      this.isConfigured = false;
      document.documentElement.classList.remove('studio-collection--configured');
      document.documentElement.classList.remove('b1-coll-band--watchware');
      if (this.isRoyal) {
        this._renderRoyalModelButtons();
        this._renderFrameTypeButtons();
      } else this._renderSizeButtons();
      this._renderFinishButtons();
      if (this.hasWatchWare) this._renderWatchWareControls();
      this._applyModeUi();
      this._updateBottomSummary();
      this._updateAllCardPreviews(false);
      this._updateProductLinks();
      return;
    }

    this.mode = resolvedMode;
    this._applyModeUi();

    if (this.mode === 'watchware') {
      var wwResolved = this.kit.resolveWatchwareFromParams
        ? this.kit.resolveWatchwareFromParams(params, this.watchWareEntries)
        : { entry: null };
      var wwParam = params.get(P.WATCHWARE);
      var entry = wwResolved.entry || this.kit.matchWatchwareFromParam(wwParam, this.watchWareEntries);
      if (entry) {
        this.watchWareModule.selectLine(this.kit.wwLineStr(entry));
        this.watchWareModule.selectEntryIndex(entry.index);
      } else if (this.watchWareEntries && this.watchWareEntries.length) {
        entry = this.watchWareEntries[0];
        this.watchWareModule.selectLine(this.kit.wwLineStr(entry));
        this.watchWareModule.selectEntryIndex(entry.index);
      }
      if (this.isRoyal) {
        var wwModelIdx = this.kit.matchModelIndexFromParam(
          params.get(P.MODEL),
          this.data.royalModels || [],
          this.norm
        );
        if (wwModelIdx != null) {
          this.bandModule.selectRoyalModel(wwModelIdx);
        }
      }
      this.isConfigured = !!this.watchWareModule.getSelectedEntry();
      if (this.isConfigured) {
        document.documentElement.classList.add('studio-collection--configured');
        document.documentElement.classList.add('b1-coll-band--watchware');
        this._renderWatchWareControls();
        if (this.isRoyal) this._renderRoyalModelButtons();
        this._enhanceProductCards();
        this._updateAllCardPreviews(true);
        this._updateProductLinks();
        this._syncUrl(replaceHistory);
      }
      return;
    }

    if (this.isRoyal) {
      var modelParam = params.get(P.MODEL);
      var frameParam = params.get(P.FRAME);
      var frameTypeParam = params.get(P.FRAME_TYPE);
      var modelIdx = this.kit.matchModelIndexFromParam(
        modelParam,
        this.data.royalModels || [],
        this.norm
      );
      if (modelIdx != null) {
        this.bandModule.selectRoyalModel(modelIdx);
      } else if (this.data.royalModels && this.data.royalModels.length) {
        this.bandModule.selectRoyalModel(0);
      }

      var frameKeyParam = frameTypeParam || frameParam;
      if (frameKeyParam && this.kit.matchFrameIndexFromParam) {
        var frameIdx = this.kit.matchFrameIndexFromParam(frameKeyParam, this.bandModule.getFrameEntries ? this.bandModule.getFrameEntries() : []);
        if (frameIdx != null && this.bandModule.selectFrameIndex) this.bandModule.selectFrameIndex(frameIdx);
      }
      this._renderRoyalModelButtons();
      this._renderFrameTypeButtons();
      this._renderFinishButtons();
      var rpFinishes = this.bandModule.getAvailableFinishes();
      var rpFinish = this.kit.matchRoyalFinishParam(params.get(P.FRAME_FINISH) || frameParam, rpFinishes);
      if (rpFinish) {
        this.bandModule.state.linkFinish = rpFinish;
      } else if (rpFinishes.length) {
        this.bandModule.state.linkFinish = rpFinishes[0];
      }

      document.documentElement.classList.remove('b1-coll-band--watchware');
      this.isConfigured =
        this.data.royalModels &&
        this.data.royalModels.length > 0 &&
        (this.bandModule.state.linkFinish != null ||
          !!(this.bandModule.getSelectedFrame && this.bandModule.getSelectedFrame()));
      if (this.isConfigured) {
        document.documentElement.classList.add('studio-collection--configured');
        this._renderRoyalModelButtons();
        this._renderFrameTypeButtons();
        this._renderFinishButtons();
        this._enhanceProductCards();
        this._updateAllCardPreviews(true);
        this._updateProductLinks();
        this._syncUrl(replaceHistory);
      }
      return;
    }

    var sizeParam = params.get(P.SIZE);
    var linkParam = params.get(P.LINK);
    var size = this.kit.matchSizeFromParam(sizeParam, this.data.appleSizes || [], this.norm);
    if (size) this.bandModule.state.deviceSize = size;

    var finishes = this.bandModule.getAvailableFinishes();
    var finish = this.kit.matchFinishFromParam(linkParam, finishes, this.norm);
    if (finish) {
      this.bandModule.state.linkFinish = finish;
    } else {
      this._coerceLinkFinishForSize();
    }

    document.documentElement.classList.remove('b1-coll-band--watchware');
    this.isConfigured = !!(this.bandModule.state.deviceSize && this.bandModule.state.linkFinish);
    if (this.isConfigured) {
      document.documentElement.classList.add('studio-collection--configured');
      this._renderSizeButtons();
      this._renderFinishButtons();
      this._enhanceProductCards();
      this._updateAllCardPreviews(true);
      this._updateProductLinks();
      this._syncUrl(replaceHistory);
    }
  };

  CollectionBandConfigurator.prototype._selectSize = function (deviceSize) {
    if (!deviceSize || this.isRoyal) return;
    this.bandModule.state.deviceSize = deviceSize;
    this._coerceLinkFinishForSize();
    this._renderSizeButtons();
    this._renderFinishButtons();
    this._updateBottomSummary();
    if (this.mode === 'direct' && this.bandModule.state.deviceSize) {
      var nextGroup = window.BrilintonStudioFlow && window.BrilintonStudioFlow.collectionNextGroup ? window.BrilintonStudioFlow.collectionNextGroup(this, 'appleSize') : 'link';
      this._openCollectionGroup(nextGroup);
      this._syncStudioSummaryValues();
      this._commitConfiguration(false);
    }
  };

  CollectionBandConfigurator.prototype._selectRoyalModel = function (modelIndex) {
    if (!this.isRoyal || isNaN(modelIndex)) return;

    this.bandModule.selectRoyalModel(modelIndex);
    this._renderRoyalModelButtons();

    if (this.mode === 'direct') {
      this._renderFrameTypeButtons();
      this._renderFinishButtons();
      if (this.bandModule.state.linkFinish || (this.bandModule.getSelectedFrame && this.bandModule.getSelectedFrame())) {
        this._commitConfiguration(false);
      }
    } else if (this.watchWareModule && this.watchWareModule.getSelectedEntry && this.watchWareModule.getSelectedEntry()) {
      this._commitConfiguration(false);
    } else {
      this._updateAllCardPreviews(this.isConfigured);
      this._updateProductLinks();
      this._syncStudioSummaryValues();
    }

    var selectedRoyalIndex = this.bandModule && this.bandModule.state
      ? this.bandModule.state.modelIndex
      : null;
    if (selectedRoyalIndex != null) {
      var selectedRoyalModel = this.data && this.data.royalModels
        ? this.data.royalModels[selectedRoyalIndex]
        : null;
      var selectedRoyalSlug = selectedRoyalModel && selectedRoyalModel.slug
        ? selectedRoyalModel.slug
        : String(selectedRoyalIndex);
      document.dispatchEvent(new CustomEvent('royal-pop:model-change', {
        detail: { modelSlug: selectedRoyalSlug, source: 'collection-studio' }
      }));
    }

    var nextGroup = window.BrilintonStudioFlow && window.BrilintonStudioFlow.collectionNextGroup
      ? window.BrilintonStudioFlow.collectionNextGroup(this, 'royalModel')
      : (this.mode === 'watchware' ? 'watchware' : 'frame');
    this._openCollectionGroup(nextGroup);
  };


  CollectionBandConfigurator.prototype._selectFrameType = function (frameIndex) {
    if (this.mode !== 'direct' || !this.isRoyal || !this.bandModule.selectFrameIndex) return;
    this.bandModule.selectFrameIndex(frameIndex);
    this._renderFrameTypeButtons();
    this._renderFinishButtons();
    if (this.data.royalModels && this.data.royalModels.length) {
      this._commitConfiguration(false);
    } else {
      this._updateAllCardPreviews(true);
      this._updateProductLinks();
      this._syncUrl(false);
    }
  };

  CollectionBandConfigurator.prototype._selectFinish = function (finish) {
    if (!finish) return;
    this.bandModule.state.linkFinish = finish;
    this._coerceLinkFinishForSize();
    this._renderFinishButtons();
    if (this.mode === 'direct') {
      if (this.isRoyal) {
        if (this.data.royalModels && this.data.royalModels.length) this._commitConfiguration(false);
      } else if (this.bandModule.state.deviceSize) {
        this._commitConfiguration(false);
      }
    } else if (this.mode === 'watchware' && this.watchWareModule.getSelectedEntry()) {
      this._commitConfiguration(false);
    }
  };

  CollectionBandConfigurator.prototype._selectWatchWareLine = function (line) {
    if (!line || !this.watchWareModule) return;
    this.watchWareModule.selectLine(line);
    this._renderWatchWareControls();
    this._syncStudioSummaryValues();
    if (this.watchWareModule.getSelectedEntry && this.watchWareModule.getSelectedEntry()) this._commitConfiguration(false);
  };

  CollectionBandConfigurator.prototype._selectWatchWareFinish = function (entryIndex) {
    if (!this.watchWareModule || isNaN(entryIndex)) return;
    this.watchWareModule.selectEntryIndex(entryIndex);
    this._renderWatchWareControls();
    this._commitConfiguration(false);
  };

  CollectionBandConfigurator.prototype._commitConfiguration = function (replaceHistory) {
    this.isConfigured = true;
    document.documentElement.classList.add('studio-collection--configured');
    document.documentElement.classList.toggle('b1-coll-band--watchware', this.mode === 'watchware');
    this._applyModeUi();
    this._enhanceProductCards();
    this._updateAllCardPreviews(true);
    this._updateProductLinks();
    this._updateBottomSummary();
    this._syncUrl(replaceHistory);
    this._syncCollectionAccordions();
  };

  CollectionBandConfigurator.prototype._getCardProductId = function (wrapper) {
    if (!wrapper) return null;
    var fromAttr = wrapper.getAttribute('data-b1-coll-product-id');
    if (fromAttr) return fromAttr;
    var idEl =
      wrapper.querySelector('[data-product-id]') ||
      wrapper.querySelector('product-info[data-product-id]');
    return idEl ? idEl.getAttribute('data-product-id') : null;
  };

  CollectionBandConfigurator.prototype._observeGrid = function () {
    var grid = document.getElementById('product-grid');
    if (!grid || typeof MutationObserver === 'undefined') return;
    var self = this;
    this._gridObs = new MutationObserver(function () {
      self._enhanceProductCards();
      if (self.isConfigured) self._updateAllCardPreviews(true);
      self._updateProductLinks();
    });
    this._gridObs.observe(grid, { childList: true, subtree: false });
  };

  CollectionBandConfigurator.prototype._enhanceProductCards = function () {
    var self = this;
    var isWw = this.mode === 'watchware';
    document.querySelectorAll('#product-grid .product-card-wrapper').forEach(function (wrapper) {
      var productId = self._getCardProductId(wrapper);
      if (!productId || !self.entriesByProductId[String(productId)]) return;

      var host = wrapper.querySelector('[data-b1-coll-preview-host]');
      var contextualSlider = wrapper.querySelector('.card-product__slider[data-bandware-profile-gallery="true"]');

      /* R44-178: preserve the established BandWare image hierarchy. A valid
         server-rendered BandWare Profile gallery is authoritative for complete-set
         cards. Studio is only a fallback when that contextual gallery is absent. */
      if (contextualSlider) {
        if (host) host.remove();
        wrapper.removeAttribute('data-b1-coll-enhanced');
        wrapper.setAttribute('data-b1-coll-context-gallery-priority', '1');
        wrapper._b1CollPreviewEngine = null;
        self._cardEngines = self._cardEngines.filter(function (item) { return item.wrapper !== wrapper; });
        return;
      }
      wrapper.removeAttribute('data-b1-coll-context-gallery-priority');
      var needsWw = isWw;
      if (host) {
        var previewRoot = host.querySelector('.studio-collection-card-preview');
        var hasWwClass = previewRoot && previewRoot.classList.contains('is-watchware-tab');
        var hasRoyalClass = previewRoot && previewRoot.classList.contains('is-royal-device');
        var needsRoyalClass = self.isRoyal && !needsWw;
        if (hasWwClass !== needsWw || hasRoyalClass !== needsRoyalClass) {
          host.remove();
          wrapper.removeAttribute('data-b1-coll-enhanced');
          wrapper._b1CollPreviewEngine = null;
          self._cardEngines = self._cardEngines.filter(function (item) {
            return item.wrapper !== wrapper;
          });
        }
      }

      if (wrapper.getAttribute('data-b1-coll-enhanced') === '1') return;

      var media = wrapper.querySelector('.card__media');
      if (!media) return;

      media.style.position = 'relative';
      var productLink = wrapper.querySelector('a.card-product__slider, .card__heading a, a.full-unstyled-link');
      host = productLink && productLink.getAttribute('href') ? document.createElement('a') : document.createElement('div');
      host.className = 'studio-collection-card-preview-host';
      host.setAttribute('data-b1-coll-preview-host', '');
      if (host.tagName === 'A') {
        host.setAttribute('href', productLink.getAttribute('href'));
        host.setAttribute('aria-label', productLink.getAttribute('aria-label') || productLink.textContent || 'View product');
      }
      var previewClasses =
        'studio-collection-card-preview studio is-ww-js-layout' +
        (needsWw
          ? ' is-watchware-tab'
          : self.isRoyal
            ? ' is-royal-device is-rp-bandware-tab is-bandware-tab'
            : ' is-bandware-tab');
      host.innerHTML =
        '<div class="' + previewClasses + '">' + previewStackInnerHtml() + '</div>';

      media.appendChild(host);
      wrapper.setAttribute('data-b1-coll-enhanced', '1');
      wrapper.setAttribute('data-b1-coll-product-id', productId);

      var previewRoot = host.querySelector('.studio-collection-card-preview');
      var engine = new self.kit.PreviewEngine(previewRoot);
      wrapper._b1CollPreviewEngine = engine;
      self._cardEngines.push({ wrapper: wrapper, engine: engine, productId: String(productId) });
    });
  };

  CollectionBandConfigurator.prototype._clearAllCardLayouts = function () {
    this._cardEngines.forEach(function (item) {
      var stack = item.engine.stacks && item.engine.stacks.active;
      if (stack && item.engine._clearWatchWareStackLayout) {
        item.engine._clearWatchWareStackLayout(stack);
      }
    });
  };

  CollectionBandConfigurator.prototype._updateAllCardPreviews = function (force) {
    var self = this;
    if (!this.isConfigured) {
      document.querySelectorAll('.studio-collection-card-preview-host').forEach(function (host) {
        host.classList.remove('is-ready');
      });
      return;
    }

    if (force) this._clearAllCardLayouts();

    this._cardEngines.forEach(function (item) {
      var entry = self.entriesByProductId[item.productId];
      if (!entry) return;

      function markReady() {
        var host = item.wrapper.querySelector('[data-b1-coll-preview-host]');
        var previewRoot = item.wrapper.querySelector('.studio-collection-card-preview');
        var stack = item.engine.stacks && item.engine.stacks.active;
        var base = stack && stack.querySelector('[data-layer="base"]');
        var band = stack && stack.querySelector('[data-layer="band"]');
        if (!host || !base || !band || !base.getAttribute('src') || !band.getAttribute('src')) return;
        if (previewRoot) previewRoot.classList.add('is-layout-ready');
        host.classList.add('is-ready');
      }

      if (self.mode === 'watchware' && self.watchWareModule) {
        var wwLayers = self.kit.buildWatchWarePreviewLayers(self.watchWareModule, entry);
        if (!wwLayers.base || !wwLayers.band) return;
        self.kit
          .renderCollectionCardPreview(item.engine, { active: wwLayers, single: true }, !!force)
          .then(markReady);
        return;
      }

      var previewRoot = item.wrapper.querySelector('.studio-collection-card-preview');
      var previewHost = item.wrapper.querySelector('[data-b1-coll-preview-host]');

      if (self.isRoyal) {
        if (previewRoot) previewRoot.classList.remove('is-layout-ready');
        self.kit.renderRoyalCollectionCardPreview(item.engine, self.bandModule, entry, !!force).then(function () {
          markReady();
        });
        return;
      }

      var layers = buildAppleCollectionDirectLayers(self.bandModule, entry);

      if (!layers.base || !layers.band) {
        if (previewRoot) previewRoot.classList.remove('is-layout-ready');
        if (previewHost) previewHost.classList.remove('is-ready');
        return;
      }

      if (previewRoot) previewRoot.classList.remove('is-layout-ready');

      self.kit
        .renderCollectionCardPreview(
          item.engine,
          { active: layers, single: true },
          !!force,
          true
        )
        .then(function () {
          markReady();
        });
    });
  };

  CollectionBandConfigurator.prototype._updateProductLinks = function () {
    var self = this;
    var config = this.isConfigured ? this._getUrlConfig() : null;

    document.querySelectorAll('#product-grid .product-card-wrapper').forEach(function (wrapper) {
      var productId = self._getCardProductId(wrapper);
      if (!productId) return;
      var entry = self.entriesByProductId[productId];
      var handle = entry && entry.productHandle;
      if (!handle) return;

      var basePath = '/products/' + handle;
      var targetPath = config
        ? self.kit.buildConfigUrl(basePath, config, false)
        : basePath;

      wrapper.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        a.setAttribute('href', targetPath);
      });

      var previewHost = wrapper.querySelector('[data-b1-coll-preview-host]');
      if (previewHost && previewHost.tagName === 'A') {
        previewHost.setAttribute('href', targetPath);
      }
    });
  };

  function bootSection(sectionId) {
    var root = document.getElementById('b1-coll-band-' + sectionId);
    var dataEl = document.getElementById('b1-coll-band-data-' + sectionId);
    if (!root || !dataEl || !getKit()) return;

    if (root._b1CollApp) {
      root._b1CollApp.destroy();
      root._b1CollApp = null;
    }

    try {
      var data = JSON.parse(dataEl.textContent);
      root._b1CollApp = new CollectionBandConfigurator(root, data);
    } catch (e) {
      console.error('Brilinton collection band configurator init failed', e);
    }
  }

  window.b1CollectionBandConfiguratorBoot = bootSection;

  function autoBoot() {
    document.querySelectorAll('[data-b1-coll-band-section]').forEach(function (el) {
      var id = el.getAttribute('data-b1-coll-band-section');
      if (id) bootSection(id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoBoot);
  } else {
    autoBoot();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var el = document.getElementById('b1-coll-band-' + ev.detail.sectionId);
    if (el && el.hasAttribute('data-b1-coll-band-section')) {
      bootSection(ev.detail.sectionId);
    }
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var root = document.getElementById('b1-coll-band-' + ev.detail.sectionId);
    if (root && root._b1CollApp) {
      root._b1CollApp.destroy();
      root._b1CollApp = null;
    }
  });
})();
